var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05013 5.05025C5.35387 4.74651 5.84633 4.74651 6.15007 5.05025L14.9496 13.8498C15.2534 14.1535 15.2534 14.646 14.9496 14.9497C14.6459 15.2535 14.1534 15.2535 13.8497 14.9497L5.05013 6.1502C4.74638 5.84646 4.74638 5.354 5.05013 5.05025Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9499 5.05025C15.2536 5.354 15.2536 5.84646 14.9499 6.1502L6.15032 14.9497C5.84658 15.2535 5.35412 15.2535 5.05038 14.9497C4.74664 14.646 4.74664 14.1535 5.05038 13.8498L13.8499 5.05025C14.1537 4.74651 14.6461 4.74651 14.9499 5.05025Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cea913366dffea2ad5793c5ece96a4ec.svg";
export { ForwardRef as ReactComponent };